import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, inject, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';
import { InstitutionExpirationWindowPipe } from '../../shared/pipes/institution-expiration-window.pipe';
import { AuthenticationModule } from '../authentication/authentication.module';
import { AppCommonModule } from '../app-common/app-common.module';
import { allComponents, publicComponents } from './components/index';
import { CorsInterceptor } from './interceptors/cors.interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';
import { AppRoutingModule } from './routing/app-routing.module';
import { AppLoggingService } from './services/app-logging.service';
import { CoreStoreModule } from './store/core-store.module';

const dataRequestProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CorsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UnauthorizedInterceptor,
    multi: true,
  },
];
const errorLoggingProviders = [
  {
    provide: ErrorHandler,
    useClass: ErrorHandlerInterceptor,
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {},
    deps: [Sentry.TraceService],
    multi: true,
  },
];

@NgModule({
  declarations: [...allComponents],
  imports: [
    AppCommonModule,
    AppRoutingModule,
    AuthenticationModule,
    CoreStoreModule,
    HttpClientModule,
    InstitutionExpirationWindowPipe,
    RouterModule,
  ],
  exports: [...publicComponents],
  providers: [
    ...(environment.logErrors ? errorLoggingProviders : []),
    ...dataRequestProviders,
  ],
})
export class CoreModule {
  private readonly _appLoggingService = inject(AppLoggingService);

  constructor() {
    this._appLoggingService.initializeErrorLogging();
  }
}
